import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple';
import Column from '~/Common-Objects/Grids/Column/Column';
import Icons from '~/Common-Objects/UI/Icons/index';
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import Row from '~/Common-Objects/Grids/Row/Row';
import helpers from '~/Classes/helpers'

import i18n from '~/i18n';

@connect((store) => {
    return { siteMaster: store.siteMaster, accountMaster: store.accountMaster }
})
class popPreviewForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: '100%'
        }
        this.changeView = this.changeView.bind(this)
    }

    componentDidMount() {
        helpers.createKey(0, 0, 0, 0).then(key => {
            this.setState({ key })
        })
    }

    changeView(view) {
        var views = ['100%', '768px', '480px']
        this.setState({
            width: views[view]
        })
    }

    render() {
        if (!this.state.key) return <LoadingIcons />

        return (
            <Paper className="mar-b0" style={{ border: 0, boxShadow: 'none' }}>
                <div style={{ position: 'absolute', top: 20, right: 35, zIndex: 1000, cursor: 'pointer' }}>
                    <div className="icon-cross2" onClick={this.props.closePreview}></div>
                </div>
                <Row className="emailPreviewHolder mar-t20" margin={0}>
                    <Column xs={12} className="mar-b25">
                        <div className="emailPreviewHolder-devices">
                            <div className="emailPreviewHolder-devices-toggle">
                                <ButtonSimple
                                    toolTipFor="desktop"
                                    className="button-simple-fullsize mar-r5"
                                    selected={this.state.width === "100%" && "selected"}
                                    onClick={() => { this.changeView(0) }}
                                    tooltip="Desktop">
                                    <Icons icon="monitor" color="#525150" />
                                </ButtonSimple>

                                <ButtonSimple
                                    toolTipFor="tablet"
                                    className="button-simple-fullsize mar-r5"
                                    selected={this.state.width === "768px" && "selected"}
                                    onClick={() => { this.changeView(1) }}
                                    tooltip="Tablet">
                                    <Icons icon="tabletOutline" color="#525150" />
                                </ButtonSimple>

                                <ButtonSimple
                                    toolTipFor="mobile"
                                    className="button-simple-fullsize "
                                    selected={this.state.width === "480px" && "selected"}
                                    onClick={() => { this.changeView(2) }}
                                    tooltip="Mobile">
                                    <Icons icon="mobileOutline" color="#525150" />
                                </ButtonSimple>
                            </div>
                            <div className="emailPreviewHolder-devices-actions">
                        <Button
                            className="button-primary"
                            iconRight={<Icons icon="arrowRight" />}
                            onClick={this.props.selectTemplate}>
                            <div dangerouslySetInnerHTML={{ __html: i18n.t('templates:add.selectAndContinue') }} />
                        </Button>
                            </div>
                        </div>
                    </Column>

                    <Column xs={12} margin={0} className="mar-b0">
                        <div className="innerPreviewHolder" style={{ maxWidth: this.state.width, margin: "0 auto" }}>
                            <iframe
                                width="100%" height="100%" style={{ border: "0", margin: "0 auto" }} src={window.location.protocol + '//' + this.props.siteMaster.trackingDomain + "/api/preview?key=" + this.state.key + "&tid=" + this.props.theme.id + "&type=theme"}
                            />
                        </div >
                    </Column >
                </Row>
            </Paper>

        );
    }
}

export default popPreviewForm;
